import type { EntityConfigDefinition, DisplayColumnConfig } from '../../types/entityConfig'
import { TABLE_SERVICE_PROVIDER } from '../../utils/displayFormatters'

const config: EntityConfigDefinition = {
  name: 'SERVICE',
  idField: 'SERVICE_ID',
  
  // SERVICE entity shows list of all services, not optimized for single service details
  useOptimizedQuery: false,
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  
  // Environment copy configuration
  preserveOnCopy: ['SERVICE_ID'],
  
  // Foreign key configuration for table display
  foreignKeys: {
    SERVICE_PROVIDER_ID: {
      table: 'SERVICE_PROVIDER',
      valueField: 'SERVICE_PROVIDER_ID',
      displayField: 'SERVICE_PROVIDER_NAME'
    }
  },
  
  // Fields to remove before GraphQL mutations
  fieldsToRemove: ['SERVICE_PROVIDER_ID_DISPLAY'],
  
  // Field lookups for display enhancement
  fieldLookups: {
    SERVICE_PROVIDER_ID: {
      lookupTable: 'SERVICE_PROVIDER',
      foreignKey: 'SERVICE_PROVIDER_ID',
      displayField: 'SERVICE_PROVIDER_NAME',
      displayFormat: TABLE_SERVICE_PROVIDER
    }
  },
  
  // Auto-create missing foreign key records
  autoCreateForeignKeys: {
    SERVICE_PROVIDER_ID: {
      entity: 'SERVICE_PROVIDER',
      matchFields: ['SERVICE_PROVIDER_NAME'],
      copyFields: ['SERVICE_PROVIDER_NAME', 'SERVICE_PROVIDER_DESC']
    }
  },
  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['SERVICE_PROVIDER_ID', 'REQUEST_TYPE', 'URI'],
    stringMatchFields: ['URI'],
    stringMatchThreshold: 0.75,
    comparisonFields: ['SERVICE_PROVIDER_ID', 'URI', 'SECRET_NAME', 'REQUEST_TYPE'],
    // Use display values for comparison instead of raw foreign key IDs
    useDisplayValues: {
      'SERVICE_PROVIDER_ID': 'SERVICE_PROVIDER_NAME'
    },
    // Display only the business values in comparison, not the IDs
    displayFieldMapping: {
      'SERVICE_PROVIDER_ID': 'SERVICE_PROVIDER_NAME'
    },
    displayFields: ['SERVICE_ID', 'SERVICE_PROVIDER_ID', 'URI', 'SECRET_NAME', 'REQUEST_TYPE', 'CREATED_BY_USER_ID', 'CREATED_DATE', 'CHANGED_BY_USER_ID', 'CHANGED_DATE'],
    resolveLookupsForBothEnvironments: true
  },
  
  // Relationship counting configuration
  relationships: {
    parameters: {
      query: 'listServiceParam',
      dataKey: 'listSERVICE_PARAM',
      countFields: ['SERVICE_ID']
    },
    stepMappings: {
      query: 'listStepServiceMapping',
      dataKey: 'listSTEP_SERVICE_MAPPING', 
      countFields: ['SERVICE_ID']
    }
  },
  
  // Display columns with foreign key lookups
  displayColumns: [
    {
      field: 'SERVICE_PROVIDER_ID',
      lookup: {
        table: 'SERVICE_PROVIDER',
        foreignKey: 'SERVICE_PROVIDER_ID',
        displayField: 'SERVICE_PROVIDER_NAME'
      }
    }
  ] as DisplayColumnConfig[],

  // Fields configuration
  fields: [
    "SERVICE_ID",
    "SERVICE_PROVIDER_ID",
    "URI",
    "SECRET_NAME",
    "REQUEST_TYPE",
    "CREATED_BY_USER_ID",
    "CREATED_DATE",
    "CHANGED_BY_USER_ID",
    "CHANGED_DATE"
  ],
  
  // Form fields configuration
  formFields: [
    {
      name: "SERVICE_PROVIDER_ID",
      type: "select",
      required: true,
      disabled: false
    },
    {
      name: "URI",
      type: "text",
      required: true,
      disabled: false
    },
    {
      name: "SECRET_NAME",
      type: "text",
      required: false,
      disabled: false
    },
    {
      name: "REQUEST_TYPE",
      type: "select",
      required: false,
      disabled: false,
      options: [
        { value: "get", label: "GET" },
        { value: "post", label: "POST" },
        { value: "put", label: "PUT" },
        { value: "delete", label: "DELETE" }
      ]
    },
    {
      name: "CREATED_BY_USER_ID",
      type: "number",
      required: false,
      disabled: false
    },
    {
      name: "CREATED_DATE",
      type: "text",
      required: false,
      disabled: true
    },
    {
      name: "CHANGED_BY_USER_ID",
      type: "number",
      required: false,
      disabled: false
    },
    {
      name: "CHANGED_DATE",
      type: "text",
      required: false,
      disabled: true
    }
  ]
}

export default config
